import { NonAppNavWrapper } from '@/components/generic/non-app-nav'
import type { NextPage } from 'next'
import { NextSeo } from 'next-seo'

const TermsOfService: NextPage = () => {
  return (
    <>
      <NextSeo
        title="v0.report - Terms of Service"
        description="Read the terms of service for using v0.report's website and services."
      />
      <NonAppNavWrapper>
        <div className="bg-white rounded-lg">
          <div className="p-6 container mx-auto pt-10">
            <h1 className="text-3xl font-bold">v0.report Terms of Service</h1>
            <p className="text-gray-500">Effective Date: September 23, 2023</p>

            <div className="divider"></div>

            <p>
              Welcome to v0.report. By accessing or using our website and services, you agree to be
              bound by these terms and conditions (the "Terms"). If you do not agree to all of the
              Terms, do not use our services.
            </p>

            <h2 className="pt-2 font-bold">Use of Services</h2>
            <p>
              You may use our services only in compliance with these Terms and all applicable laws,
              regulations, and generally accepted practices or guidelines in the relevant
              jurisdictions.
            </p>

            <h2 className="pt-2 font-bold">User Responsibilities</h2>
            <p>
              You are responsible for your use of the website and services, including the legality
              of any content uploaded, shared, or created using our services.
            </p>

            <h2 className="pt-2 font-bold">Account Registration and Use</h2>
            <p>
              You must provide accurate and complete information when creating an account. You are
              responsible for maintaining the confidentiality of your account and password and for
              restricting access to your computer.
            </p>

            <h2 className="pt-2 font-bold">Intellectual Property Rights</h2>
            <p>
              All content provided on the website and services, including but not limited to text,
              graphics, logos, images, and software, is the property of v0.report or its content
              suppliers and protected by international copyright laws.
            </p>

            <h2 className="pt-2 font-bold">Disclaimers</h2>
            <p>
              Our website and services are provided on an "as is" and "as available" basis.
              v0.report makes no representations or warranties of any kind, express or implied, as
              to the operation of our services or the information, content, materials, or products
              included on our services.
            </p>

            <h2 className="pt-2 font-bold">Limitation of Liability</h2>
            <p>
              v0.report will not be liable for any damages of any kind arising from the use of our
              services, including, but not limited to direct, indirect, incidental, punitive, and
              consequential damages.
            </p>

            <h2 className="pt-2 font-bold">Changes to the Terms</h2>
            <p>
              We reserve the right, at our sole discretion, to modify or replace these Terms at any
              time. If a revision is material, we will try to provide at least 30 days' notice prior
              to any new terms taking effect.
            </p>

            <h2 className="pt-2 font-bold">Contact Us</h2>
            <p>If you have any questions about these Terms, please contact us at team@v0.report.</p>
          </div>
        </div>
      </NonAppNavWrapper>
    </>
  )
}

export default TermsOfService
